import firebase from "firebase";

var firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTHDOMAIN,
  databaseURL: process.env.REACT_APP_BASEURL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGEBUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID
};
// Initialize Firebase
if (typeof window !== "undefined") {
  if (!firebase.apps.length) firebase.initializeApp(firebaseConfig);
  // Analytics must never prevent authentication from starting.
  if (firebase.analytics && firebase.analytics.isSupported) {
    firebase.analytics.isSupported().then(supported => {
      if (supported) firebase.analytics();
    }).catch(() => {});
  }
}
export default firebase;